import { render, staticRenderFns } from "./upLoadSuccess.vue?vue&type=template&id=0c039507&scoped=true&"
import script from "./upLoadSuccess.vue?vue&type=script&lang=js&"
export * from "./upLoadSuccess.vue?vue&type=script&lang=js&"
import style0 from "./upLoadSuccess.vue?vue&type=style&index=0&id=0c039507&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c039507",
  null
  
)

export default component.exports